// src/components/ProtectedRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Loading from "./Loading";
import AlertModal from "./AlertModal";
import { useSignOut } from "../../actions/SignOutAction";

const ProtectedRoute = ({ children, redirectTo = "/signin" }) => {
  const location = useLocation();
  const signOut = useSignOut();
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [redirect, setRedirect] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem("username");
    const adminId = localStorage.getItem("adminId");
    const adminUid = localStorage.getItem("adminUid");

    const isUserValid = username && adminId && adminUid;

    if (!isUserValid) {
      signOut();
      setShowAlert(true);
    } else {
      setIsAuthenticated(true);
    }
  }, [location, signOut]);

  const handleAlertConfirm = () => {
    setShowAlert(false);
    setRedirect(true);
  };

  if (isAuthenticated === null && !showAlert && !redirect) {
    return <Loading />;
  }

  if (redirect) {
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <>
      {showAlert && (
        <AlertModal
          message="Unauthorized access detected. Your session has expired. Please sign in again to continue."
          onConfirm={handleAlertConfirm}
        />
      )}
      {isAuthenticated && children}
    </>
  );
};

export default ProtectedRoute;
